import API from './axios';

// Support Management API Service
export const supportService = {
  // Get all support tickets with filters
  getAllTickets: async (params = {}) => {
    const { page = 1, limit = 20, status } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status })
    });

    const response = await API.get(`/admin/support/tickets?${queryParams}`);
    return response.data;
  },

  // Get a specific support ticket by ID
  getTicketById: async (ticketId) => {
    const response = await API.get(`/admin/support/tickets/${ticketId}`);
    return response.data;
  },

  // Update a support ticket
  updateTicket: async (ticketId, updateData) => {
    const response = await API.put(`/admin/support/tickets/${ticketId}`, updateData);
    return response.data;
  },

  // Resolve a support ticket
  resolveTicket: async (ticketId, resolutionData) => {
    const response = await API.post(`/admin/support/tickets/${ticketId}/resolve`, resolutionData);
    return response.data;
  },

  // Get ticket statistics
  getTicketStats: async () => {
    try {
      const allTickets = await supportService.getAllTickets({ limit: 1000 });
      if (allTickets.success) {
        const tickets = allTickets.data.tickets;
        const stats = {
          total: tickets.length,
          open: tickets.filter(t => t.status === 'OPEN').length,
          inProgress: tickets.filter(t => t.status === 'IN_PROGRESS').length,
          resolved: tickets.filter(t => t.status === 'RESOLVED').length,
          closed: tickets.filter(t => t.status === 'CLOSED').length,
          urgentPriority: tickets.filter(t => t.priority === 'Urgent').length,
          highPriority: tickets.filter(t => t.priority === 'High').length,
          mediumPriority: tickets.filter(t => t.priority === 'Medium').length,
          lowPriority: tickets.filter(t => t.priority === 'Low').length
        };
        return { success: true, data: stats };
      }
      return { success: false, data: {} };
    } catch (error) {
      console.error('Error getting ticket stats:', error);
      return { success: false, data: {} };
    }
  }
};

export default supportService;
